import React, { useState } from 'react';

import _ from 'lodash';
import { CSVLink } from 'react-csv';
import Avatar from '@material-ui/core/Avatar';
import { IconButton } from '@material-ui/core';
import { MdDownload } from 'react-icons/md';
import { useSources } from 'hooks';
import API from 'utils/api';
import { Table, Tooltip } from 'components';

import styles from './ChannelAnalytics.module.scss';

const ChannelAnalytics = () => {
  const [dataReport, setDataReport] = useState([]);
  const [csvLink, setCsvLink] = useState();
  const [totalCount, setTotalCount] = useState(0);

  const sources = useSources();

  const exportCSV = () => {
    API.getUserChannelAnalytics(
      {
        pageSize: totalCount,
        page: 1,
      },
      sources
    ).then(({ data }) => {
      if (data.docs && data.docs.length) {
        const channels = data.docs.map(channel => {
          return {
            name: channel.name,
            members: channel.users_count,
          };
        });

        setDataReport(channels);
        csvLink.link.click();
      }
    });
  };

  const fetchData = async ({ pageSize, page }) => {
    return API.getUserChannelAnalytics(
      {
        pageSize,
        page,
      },
      sources
    ).then(data => {
      setTotalCount(data.total);
      return data;
    });
  };

  const renderControlPanel = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton onClick={exportCSV}>
          <Tooltip title="Click to export table data" placement="top">
            <MdDownload />
          </Tooltip>
        </IconButton>
      </div>
    );
  };

  const columns = [
    {
      title: 'Channel',
      field: 'name',
      render: rowData => {
        const words = rowData.name.split(' ');
        let abrevName = '';
        if (words.length >= 2) {
          abrevName = words[0][0] + words[1][0];
        }

        if (words.length === 1) {
          abrevName = _.get(rowData, 'name.0', '') + '' + _.get(rowData, 'name.1', '');
        }

        return (
          <div className={styles.displayName}>
            <Avatar className={styles.avatar} src={rowData.logoUrl}>
              {abrevName}
            </Avatar>
            {rowData.name}
          </div>
        );
      },
    },
    { title: 'Members', field: 'users_count' },
  ];

  return (
    <div className={styles.userChannelStatistics}>
      <div className={styles.tableContainer}>
        <CSVLink
          data={dataReport}
          filename="data.csv"
          className="hidden"
          ref={r => setCsvLink(r)}
          target="_blank"
        />
        <Table
          controlPanel={renderControlPanel()}
          columns={columns}
          data={fetchData}
          title="Channels"
          search={false}
        />
      </div>
    </div>
  );
};

export default ChannelAnalytics;
